module.exports = __webpack_public_path__ + "static/media/together1.0c19ff77.jpg";